const modal = document.getElementById('joii-quick-add-modal');
const modalContent = document.getElementById('joii-quick-add-content');
const closeBtn = modal.querySelector('.close');
var product = null;

document.addEventListener("DOMContentLoaded", () => {
  //console.log('%cJOII QUICK ADD', 'color: green; font-weight: bold;');

  document.addEventListener('click', handleDocumentClick);

  closeBtn.addEventListener('click', closeQuickAdd);

  modal.addEventListener('click', (e) => {
    if (e.target !== modal && !e.target.closest('.joii-quick-add')) return;

    e.preventDefault();
    e.stopPropagation();

    closeQuickAdd();

    var thisQuickAdd = document.querySelector(".joii-quick-add.active");
    if (thisQuickAdd !== null && !modal.classList.contains("hidden")) {
      thisQuickAdd.classList.remove("active");
      thisQuickAdd.classList.remove("finished");
    }
  });
});


function handleDocumentClick(e) {

  // Quick add trigger
  const quickAdd = e.target.closest('.joii-quick-add');
  if (quickAdd) {
    e.preventDefault();   // stops <a> navigation
    e.stopPropagation();

    const handle = quickAdd.dataset.productHandle;
    openQuickAdd(handle, quickAdd);
    return;
  }

  // Quantity buttons
  const qtyBtn = e.target.closest('.qa-quantity-button');
  if (qtyBtn) {
    e.preventDefault();
    e.stopPropagation();

    qaHandleQuantityButton(qtyBtn);
    return;
  }
}


function qaHandleQuantityButton(qtyBtn) {
  const qtyWrapper = qtyBtn.closest(".joii-qa-qty");
  const qtyInput = qtyWrapper.querySelector("input");
  const qtyIncrement = parseInt(qtyInput.getAttribute("step"), 10);
  const currentQty = parseInt(qtyInput.value, 10) || 0;
  //console.log(currentQty);
  if (qtyBtn.title == "Increase") {
    qtyInput.value = currentQty + qtyIncrement;
  }
  if (qtyBtn.title == "Decrease") {
    qtyInput.value = currentQty - qtyIncrement;
  }
  //console.log(qtyInput);
  return true;
}



function closeQuickAdd() {
  modal.classList.add("hidden");
  modalContent.innerHTML = '';
  var thisQuickAdd = document.querySelector(".joii-quick-add.active");
  if (thisQuickAdd !== null) {
    thisQuickAdd.classList.remove("active");
    thisQuickAdd.classList.add("finished");
  }
}


async function openQuickAdd(handle,quickAdd) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Product fetch failed');

    product = await res.json();

    var has_plans = true;
    if (!product.selling_plan_groups || product.selling_plan_groups.length == 0) has_plans = false;

    //console.log(product.variants.length);
    //console.log(has_plans);

    //console.log(product);
    if (product.variants.length == 1 && product.variants[0].available && !has_plans) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: product.variants[0].id,
          quantity: 1
        })
      });
      quickAdd.classList.add("finished");
      quickAddUpdateCartNumber();
    } else {
      renderQuickAdd(product);
      modal.classList.remove("hidden");
    }

    quickAdd.classList.add("active");

  } catch (err) {
    console.error(err);
  }
}


function renderQuickAdd(product) {
  const firstAvailableVariant =
    product.variants.find(v => v.available) || product.variants[0];

  modalContent.innerHTML = `
    <div class="joii-quick-add-inner">
      <a class="joii-qa-images" href="${product.url}">
        <img
          id="joii-qa-image"
          src="${product.images[0]}&width=400"
          alt="${product.title}"
          loading="eager"
        />
      </a>

      <div class="joii-qa-info">
        <div style="display: flex; flex-direction: column;">
          <h2 class="h2 product-heading" style="cursor: pointer;"><a style="color: black;" href="${product.url}">${product.title}</a></h2>
          <div class="product-price">
            <span class="price-item actual-price h3" id="joii-qa-price">${formatMoney(firstAvailableVariant.price)}</span>
          </div>
        </div>

        ${renderOptions(product)}

        ${renderSellingPlans(product)}

        <div class="joii-add-wrapper">
          <div class="product-quantity-wrapper" style="border: 2px solid #207EA7;">
            <div class="product-quantity-inner joii-qa-qty" data-quantity-wrapper="">
              <button type="button" class="qa-quantity-button no-js-hidden" data-quantity-decrement="" title="Decrease">
                <span class="hidden">Decrease</span>
                <svg x="0px" y="0px" width="10px" height="10px" viewBox="0 0 14 14">
                  <rect x="6" transform="matrix(6.123234e-17 -1 1 6.123234e-17 0 14)" width="2.1" height="14"></rect>
                </svg>
              </button>
              <input type="number" id="joii-qa-qty" value="1" min="1" class="quantity-input product-quantity" name="quantity" step="1" data-quantity-input="" placeholder="1">
              <button type="button" class="qa-quantity-button no-js-hidden" data-quantity-increment="" title="Increase">
                <span class="hidden">Increase</span>
                <svg x="0px" y="0px" width="10px" height="10px" viewBox="0 0 14 14">
                  <polygon points="14,6 8,6 8,0 6,0 6,6 0,6 0,8 6,8 6,14 8,14 8,8 14,8 "></polygon>
                </svg>
              </button>
            </div>
          </div>
          <button id="joii-qa-add" style="background: #207EA7; border: 1px solid #207EA7;" data-variant-id="${firstAvailableVariant.id}" class="hideAddfalse medium-btn button"><span>Add to basket</span></button>
          <div class="hideAddfalse medium-btn button trigger_joii_add_cart_popup" style="display: none; line-height: unset;"><span>Add to basket</span></div>
          <div style="display: none !important;" class="wishlist-engine joii-wishlist-btn-prod-page" data-product_id="" data-variant_id="" data-full_button="false" data-css="true"></div>
          
        </div>
      </div>
    </div>
  `;

  const qaSeeMore = modal.querySelector(".joii-quick-add-see-more");
  qaSeeMore.setAttribute("href",`${product.url}`);

  bindVariantEvents(product);
  bindAddToCart();
}




// function renderOptions(product) {
//   if (product.options.length === 1 && product.variants.length === 1) {
//     return '';
//   }

//   return product.options.map((option, index) => {
//     const variantOptions = [...new Set(product.variants.map(v => v.options[index]))];

//     return `
//       <div class="joii-qa-option" data-option-index="${index}">
//         <p style="margin-bottom: 10px;">${option.name}:</p>
//         <ul class="joii-qa-option-values product-selector-option-list">
//           ${variantOptions.map(variant => `
//             <li class="variant-option" type="button" data-value="${variant}">
//               <div class="option">${variant}</div>
//             </li>
//           `).join('')}
//         </ul>
//       </div>
//     `;
//   }).join('');
// }

function renderOptions(product) {
  if (product.options.length === 1 && product.variants.length === 1) {
    return '';
  }

  return product.options.map((option, index) => {
    const variantOptions = [...new Set(product.variants.map(v => v.options[index]))];

    return `
      <div class="joii-qa-option" data-option-index="${index}">
        <label style="margin-bottom: 6px; display: block;">${option.name}</label>
        <select class="joii-qa-option-select">
          ${variantOptions.map(value => `
            <option value="${value}">${value}</option>
          `).join('')}
        </select>
      </div>
    `;
  }).join('');
}



function renderSellingPlans(product) {
  if (
    !product ||
    !product.selling_plan_groups ||
    product.selling_plan_groups.length === 0
  ) {return '';}

  return `
    <div class="selling_plan_app_container joii-subscriptions-container" style="display: block !important;">
      <style>
          .product-price-block  {display: none !important;}
          .joii-sub-ppw {/*display: none;*/}
          .selling_plan_theme_integration--hidden {display: none;}
      </style>

      ${product.variants.map(variant => `
      <section id="singleRepeatToggle_${variant.id}" data-variant-id="${variant.id}" class="single-repeat-toggle-cont selling_plan_theme_integration section-in-view selling_plan_theme_integration--hidden" style="">
        <div class="joii_toggle_subscription_wrapper">

          <div class="joii_toggle_subscription joii_toggle_sub_one" data-variant-id="${variant.id}" data-radio-type="one_time_purchase">
            <div class="joii-plan-row">
            <label> Single Purchase </label>
            <div class="joii-sub-prices">
              <span class="joii-sub-price">${formatMoney(variant.price)}</span>
            </div>
                ${variant.weight > 0 ? `<span class="joii-sub-ppw">${formatMoney((variant.price / variant.weight) * 1000)}/kg</span>` : ``}
            </div>
          </div>

          <div class="joii_toggle_subscription" data-variant-id="${variant.id}" data-radio-type="selling_plan">
            <div class="joii-plan-row">
              <label> Repeat &amp; Save </label>
                <div class="joii-sub-prices">
                  <span class="joii-sub-price">${formatMoney(variant.selling_plan_allocations[0].price)}</span>
                </div>
                ${variant.weight > 0 ? `<span class="joii-sub-ppw">${formatMoney((variant.selling_plan_allocations[0].price / variant.weight) * 1000)}/kg</span>` : ``}
            </div>
          </div>
        </div>
      </section>
        `).join('')}
    </div>

    ${product.variants.map(variant => `
    <div id="sellingPlanDropdownContainer_${variant.id}" class="selling-plan-dropdown-container" data-variant-id="${variant.id}" style="display: none;">
      <label class="joii-prod-choose-plan-label" for="sellingPlan_${variant.id}">Choose your frequency:</label>
      <div class="joii-repeats-box">
        <button type="button" class="joii-selling-plan-toggle-dropdown-btn" variant-id="${variant.id}">
          <div class="joii-chosen-plan-container">
            ${product.selling_plan_groups.map(plan_group => `
              ${variant.selling_plan_allocations[0].selling_plan_group_id == plan_group.id ? `
                ${plan_group.selling_plans.map(plan => `
                  ${variant.selling_plan_allocations[0].selling_plan_id == plan.id ? `
                    <span class="joii-selling-plan-label">${plan.name}</span>
                    <span class="joii-selling-plan-discount" joii-disc-data="" style="display: none; font-size: 12px;">Save ${plan.price_adjustments[0].value_type == "percentage" ? `${plan.price_adjustments[0].value}%` : `${formatMoney(plan.price_adjustments[0].value)}`}</span>
                  `:``}
                `).join('')}
              `:``}
            `).join('')}
          </div>
        </button>
        <div id="sellingPlanDropdown_${variant.id}" class="joii-selling-plan-options joii-sub-popup" data-plan-id="4358766817" name="selling_plan_${variant.id}" style="display: none;">
          ${variant.selling_plan_allocations.map(allocation => `
            ${product.selling_plan_groups.map(plan_group => `
              ${plan_group.selling_plans.map(plan => `
                ${allocation.selling_plan_id == plan.id ? `
                  <div class="joii-selling-plan-option-box" group-name="${plan_group.name}" data-variant-id="${variant.id}" data-plan-id="${plan.id}" data_plan_name="${plan.name}" data-price="${formatMoney(allocation.price)}" data-price-adj="" data_plan_discount="">
                    <span class="joii-sell-plan-name">${plan.name}</span>
                    <span class="joii-sell-plan-discount" style="display: none; font-size: 12px;">${plan.price_adjustments[0].value_type == "percentage" ? `${plan.price_adjustments[0].value}%` : `${formatMoney(plan.price_adjustments[0].value)}`}</span>
                  </div>
                `:``}
              `).join('')}
            `).join('')}
          `).join('')}
        </div>
      </div>

            
      <div class="joii-sell-plan-descriptions">
        ${variant.selling_plan_allocations.map(allocation => `
          ${product.selling_plan_groups.map(plan_group => `
            ${plan_group.selling_plans.map(plan => `
              ${allocation.selling_plan_group_id == plan.id ? `
                <div class="joii-selling-plan-option-description" group-name="${plan_group.name}" data-variant-id="${variant.id}" data-plan-id="${plan.id}" data_plan_name="${plan.name}" data-price="${formatMoney(allocation.price)}" data-price-adj="" data_plan_discount="">
                  <p>${plan.description}</p>
                </div>
              `:``}
            `).join('')}
          `).join('')}
        `).join('')}
      </div>

    </div>
    `).join('')}
  `;
}





function bindVariantEvents(product) {
  const optionWrappers = modalContent.querySelectorAll('.joii-qa-option');
  const planContainers = modalContent.querySelectorAll('.selling-plan-dropdown-container');
  const togglePlanDropdowns = modalContent.querySelectorAll(".joii-selling-plan-toggle-dropdown-btn");
  const planDropdowns = modalContent.querySelectorAll('.joii-selling-plan-options');
  const planBtns = modalContent.querySelectorAll(".joii-selling-plan-option-box");
  const repeatToggles = modalContent.querySelectorAll(".single-repeat-toggle-cont");
  const repeatToggleBtns = modalContent.querySelectorAll(".joii_toggle_subscription");


  const selects = modalContent.querySelectorAll('.joii-qa-option-select');

  selects.forEach(select => {
    select.addEventListener('change', () => {
      const selectedOptions = getSelectedOptions();
      if (selectedOptions.includes(null)) return;

      const variant = findMatchingVariant(product, selectedOptions);
      if (!variant) return;

      modalContent.setAttribute("variant-id", variant.id);

      repeatToggles.forEach(rToggle => {
        rToggle.classList.toggle(
          'active',
          rToggle.id === `singleRepeatToggle_${variant.id}`
        );
      });

      updateSelectedVariant(product);
    });
  });


  optionWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', (e) => {
      const btn = e.target.closest('.option');
      if (!btn) return;

      // UI active state
      wrapper.querySelectorAll('.option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');


      var selectedOptions = getSelectedOptions();
      //console.log(selectedOptions);
      if (selectedOptions.includes(null)) return;
      var variant = findMatchingVariant(product, selectedOptions);
      //console.log(variant);
      modalContent.setAttribute("variant-id",variant.id);
      //const variant_id = btn.getAttribute("variant-id");

      repeatToggles.forEach(rToggle => {
        if (rToggle.id == `singleRepeatToggle_${variant.id}`) {
          rToggle.classList.add('active');
        } else {
          rToggle.classList.remove('active');
        }
      });

      // planOptions.forEach(planOption => {
      //   if (planOption.id == `sellingPlanDropdown_${variant.id}"`) {
      //     planOption.classList.add('active');
      //   } else {
      //     planOption.classList.remove('active');
      //   }
      // });

      updateSelectedVariant(product);
    });
  });

  // Auto-select first value of each option
  optionWrappers.forEach(wrapper => {
    const firstBtn = wrapper.querySelector('.option');
    if (firstBtn) firstBtn.classList.add('active');
  });
  var selectedOptions = getSelectedOptions();
  //console.log(selectedOptions);
  if (selectedOptions.includes(null)) return;
  var variant = findMatchingVariant(product, selectedOptions);
  if (!variant) {
    variant = product.variants[0];
  }
  //console.log(variant);
  modalContent.setAttribute("variant-id",variant.id);


  if (repeatToggles.length > 0) {
    repeatToggles[0].classList.add("active");
    var toggleSingles = modalContent.querySelectorAll(".joii_toggle_subscription.joii_toggle_sub_one");
    toggleSingles.forEach(toggleSingle => {
      toggleSingle.classList.add("active");
    });
  }
  
  repeatToggleBtns.forEach(repeatToggleBtn => {
    repeatToggleBtn.addEventListener('click', (e) => {
      var variant_id = modalContent.getAttribute("variant-id");
      if (repeatToggleBtn.classList.contains("joii_toggle_sub_one")) {
        repeatToggleBtns.forEach(rtb => {
          if (rtb.classList.contains("joii_toggle_sub_one")) {
            rtb.classList.add("active");
          } else {
            rtb.classList.remove("active");
          }
        });
        modalContent.classList.add("single");
        modalContent.classList.remove("sub");
        planContainers.forEach(planCont => {
          planCont.classList.remove('active');
        });
      } else {
        repeatToggleBtns.forEach(rtb => {
          if (rtb.classList.contains("joii_toggle_sub_one")) {
            rtb.classList.remove("active");
          } else {
            rtb.classList.add("active");
          }
        });
        modalContent.classList.add("sub");
        modalContent.classList.remove("single");
        planContainers.forEach(planCont => {
          if (planCont.id == `sellingPlanDropdownContainer_${variant_id}`) {
            planCont.classList.add('active');
          } else {
            planCont.classList.remove('active');
          }
        });
      }
    });
  });

  togglePlanDropdowns.forEach(togglePlanDropdown => {
    togglePlanDropdown.addEventListener('click', (e) => {
      const dropWrap = togglePlanDropdown.closest(".joii-repeats-box");
      if (dropWrap.classList.contains("active")) {
        dropWrap.classList.remove('active');
        planDropdowns.forEach(planDropdown => {
          planDropdown.classList.remove('active');
        });
      } else {
        dropWrap.classList.add('active');
        planDropdowns.forEach(planDropdown => {
          if (planDropdown.id == `sellingPlanDropdown_${togglePlanDropdown.getAttribute("variant-id")}`) {
            planDropdown.classList.add('active');
          } else {
            planDropdown.classList.remove('active');
          }
        });
      }
      //console.log(dropWrap);
    });
  });


  planBtns.forEach(planBtn => {
    planBtn.addEventListener('click', (e) => {
      const dropWrap = planBtn.closest(".joii-repeats-box");
      dropWrap.classList.remove('active');
      const planLabel = dropWrap.querySelector(".joii-selling-plan-label")
      planLabel.textContent = planBtn.getAttribute("data_plan_name");
      planLabel.setAttribute("chosen-plan",planBtn.getAttribute("data-plan-id"));
      planDropdowns.forEach(planDropdown => {
        planDropdown.classList.remove('active');
      });
    });
  });

  updateSelectedVariant(product);
}

function qaSetSinglePrice(price,compare_at_price) {

}
function qaSetSubPrice(price,compare_at_price) {

}


// function getSelectedOptions() {
//   return Array.from(
//     modalContent.querySelectorAll('.joii-qa-option')
//   ).map(wrapper => {
//     const active = wrapper.querySelector('.option.active');
//     return active ? active.textContent.trim() : null;
//   });
// }

function getSelectedOptions() {
  return Array.from(
    modalContent.querySelectorAll('.joii-qa-option-select')
  ).map(select => select.value || null);
}


function findMatchingVariant(product, selectedOptions) {
  return product.variants.find(variant =>
    variant.options.every((opt, index) => opt === selectedOptions[index])
  );
}




// function updateSelectedVariant(product) {
//   const selectedOptions = Array.from(
//     modalContent.querySelectorAll('.joii-qa-option')
//   ).map(wrapper =>
//     wrapper.querySelector('button.active')?.dataset.value
//   );

//   const variant = product.variants.find(v =>
//     v.options.every((opt, i) => opt === selectedOptions[i])
//   );

//   if (!variant) {
//     console.log("no variant")
//     return;
//   }

//   document.getElementById('joii-qa-price').textContent = formatMoney(variant.price);

//   document.getElementById('joii-qa-add').dataset.variantId = variant.id;

//   // Optional: update image
//   if (variant.featured_image) {
//     document.getElementById('joii-qa-image').src =
//       variant.featured_image.src;
//   }
// }

function updateSelectedVariant(product) {
  const selectedOptions = Array.from(
    modalContent.querySelectorAll('.joii-qa-option-select')
  ).map(select => select.value);

  const variant = product.variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!variant) {
    console.log("no variant", selectedOptions);
    return;
  }

  modalContent.setAttribute("variant-id", variant.id);

  document.getElementById('joii-qa-price').textContent =
    formatMoney(variant.price);

  document.getElementById('joii-qa-add').dataset.variantId = variant.id;

  if (variant.featured_image) {
    document.getElementById('joii-qa-image').src =
      variant.featured_image.src;
  }
}






function bindAddToCart() {
  const btn = document.getElementById('joii-qa-add');

  btn.addEventListener('click', async () => {
    const variantId = modalContent.getAttribute("variant-id");
    const qty = Number(document.getElementById('joii-qa-qty').value);

    const plan_id = modalContent
    .querySelector(".selling-plan-dropdown-container.active .joii-selling-plan-label")
    ?.getAttribute("chosen-plan");

    btn.disabled = true;
    btn.textContent = 'Adding…';

    if (modalContent.classList.contains("sub") && plan_id !== null) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          selling_plan: plan_id
        })
      });
    } else {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty
        })
      });
    }

    var thisQuickAdd = document.querySelector(".joii-quick-add.active");
    if (thisQuickAdd !== null) {
      thisQuickAdd.classList.remove("active");
      thisQuickAdd.classList.add("finished");
    }
    quickAddUpdateCartNumber();
    btn.textContent = 'Added!';
    //setTimeout(closeQuickAdd, 800);
    closeQuickAdd();
  });
}


async function quickAddUpdateCartNumber() {
  const cartIcon = document.querySelector('.header-icons-link.cart');

  if (!cartIcon) {
    const cartIcon = document.querySelector('.header-icons-link.cart');

    const cartCount = document.createElement('span');
    cartCount.className = 'cart-count';
    cartCount.setAttribute('data-header-cart-count', '');
    cartIcon.appendChild(cartCount);
  }

  const cartNum = document.querySelector('.cart-count');
  if (!cartNum) {return;}

  try {
    const cartRes = await fetch('/cart.js');
    if (!cartRes.ok) throw new Error('Cart fetch failed');

    const cart = await cartRes.json();

    //console.log('Cart item count:', cart.item_count);
    cartNum.textContent = cart.item_count;

    if (cart.item_count == 0) {
      cartNum.classList.add("hidden");
    } else {
      cartNum.classList.remove("hidden");
    }

  } catch (err) {
    console.error('Failed to update cart count', err);
  }

  try {
    var skelCartItem = addToCartSkeleton();
    addToCartItems(skelCartItem);
  } catch (err) {}
}



function formatMoney(cents) {
  const curSymbol = document.body.getAttribute("currency-symbol");
  return `${curSymbol}${(cents / 100).toFixed(2)}`;
}




/* =====================================================================
   OOS MODE: "Show alternatives"
   REPLACES the earlier "OOS MODE" block at the end of
   assets/joii-quick-add.js (currently from the header comment around
   line 695 to the end of the file).

   Trigger: .joii-qa-alternatives-btn, rendered by joii-quick-add.liquid
   when a product is fully out of stock and has in-stock
   custom.alternatives. Opens the existing quick add modal with the
   alternatives in metafield order, laid out like "Top Rated by
   Category" (sections/joii-shop-discovery-intro.liquid):
     - same theme carousel structure and classes: .joii-product-grid,
       .joii-product-grid-controls with grid-button-previous/next arrows,
       .joii-product-grid-wrapper, .joii-product-grid-dots
     - same quick add button: real .joii-quick-add markup and icons, so
       joii-custom.css styles it exactly like the product cards
       (white box, navy "+", green tick when added)
   Simple alternative (1 variant, no Repeat & Save): "+" adds straight to
   the basket and shows the tick. Anything else: "+" opens the normal
   quick add view with a "Back to alternatives" link.

   Why the carousel is driven here: joii-slideshow.js only reveals the
   arrows, builds the dots and binds scroll syncing for grids that exist
   at page load, and its helpers aren't callable from outside. This block
   does the same for the popup grid, using the same maths.
   Default mode (.joii-quick-add on product cards) is untouched.
   ===================================================================== */

const qaAltState = { source: null, products: [], info: {}, token: 0 };


// Capture phase on window: runs before the modal's backdrop handler (which
// closes the modal on any .joii-quick-add click) and before the default
// quick add handler, so the alternatives "+" can reuse the real classes.
window.addEventListener('click', (e) => {
  const altTrigger = e.target.closest('.joii-qa-alternatives-btn');
  if (altTrigger) {
    e.preventDefault();
    e.stopPropagation();
    openAlternatives(altTrigger);
    return;
  }

  if (!e.target.closest('.joii-qa-alt, .joii-qa-alt-back')) return;

  const altAdd = e.target.closest('.joii-qa-alt-add');
  if (altAdd) {
    e.preventDefault();
    e.stopPropagation();
    qaAltAdd(altAdd);
    return;
  }

  const arrow = e.target.closest('.grid-button-previous, .grid-button-next');
  if (arrow) {
    e.preventDefault();
    e.stopPropagation();
    qaGridArrow(arrow);
    return;
  }

  const dot = e.target.closest('.joii-product-grid-dot');
  if (dot) {
    e.preventDefault();
    e.stopPropagation();
    qaGridDot(dot);
    return;
  }

  const altBack = e.target.closest('.joii-qa-alt-back');
  if (altBack) {
    e.preventDefault();
    e.stopPropagation();
    renderAlternatives();
  }
}, true);


async function openAlternatives(trigger) {
  const token = ++qaAltState.token;
  const handles = (trigger.dataset.alternatives || '')
    .split(',')
    .map(h => h.trim())
    .filter(Boolean);

  qaAltState.source = {
    title: trigger.dataset.productTitle || '',
    url: trigger.dataset.productUrl || ''
  };
  qaAltState.products = [];

  // Title + variant hint per handle, rendered by the theme snippets in
  // joii-quick-add.liquid: { handle: { t: titleHtml, v: hintText } }
  try {
    qaAltState.info = JSON.parse(trigger.dataset.altInfo || '{}');
  } catch (err) {
    qaAltState.info = {};
  }

  qaAltInjectStyles();
  qaAltSetSeeMore();
  modalContent.innerHTML = `
    <div class="joii-qa-alt">
      <p class="joii-qa-alt-loading">Finding alternatives…</p>
    </div>
  `;
  modal.classList.remove('hidden');

  const results = await Promise.allSettled(
    handles.map(h =>
      fetch(`/products/${encodeURIComponent(h)}.js`).then(r => (r.ok ? r.json() : null))
    )
  );

  // Closed, or another card opened, while we were fetching
  if (token !== qaAltState.token || modal.classList.contains('hidden')) return;

  // Stock can change after the page was cached, so re-check availability here
  qaAltState.products = results
    .map(r => (r.status === 'fulfilled' ? r.value : null))
    .filter(p => p && p.available);

  renderAlternatives();
}


function renderAlternatives() {
  const src = qaAltState.source || {};
  const items = qaAltState.products;
  qaAltSetSeeMore();

  const intro = !items.length
    ? 'Sorry, none of the alternatives are in stock right now either.'
    : items.length === 1
      ? 'Here is an in-stock alternative:'
      : 'Here are some in-stock alternatives:';

  if (!items.length) {
    modalContent.innerHTML = `
      <div class="joii-qa-alt">
        <div class="joii-qa-alt-head">
          <div class="joii-qa-alt-head-text">
            <div class="joii-qa-alt-badges"><span class="product-badge sold-badge">Out Of Stock</span></div>
            <h2 class="h3">${qaEsc(src.title)}</h2>
            <p>${intro}</p>
          </div>
        </div>
      </div>
    `;
    return;
  }

  // Same 3-row, column-flowing grid as Top Rated; fewer rows for short lists
  const rows = Math.min(3, items.length);

  // Arrow markup is snippets/joii-product-grid-arrows.liquid with the
  // 'previous' / 'next' icons from snippets/icons.liquid
  modalContent.innerHTML = `
    <div class="joii-qa-alt joii-product-grid">
      <div class="joii-qa-alt-head">
        <div class="joii-qa-alt-head-text">
          <div class="joii-qa-alt-badges"><span class="product-badge sold-badge">Out Of Stock</span></div>
          <h2 class="h3">${qaEsc(src.title)}</h2>
          <p>${intro}</p>
        </div>
        <div class="joii-product-grid-controls">
          <button class="grid-button-previous" type="button" aria-label="Previous" style="display: none;">
            <svg class="custom-navigation-button-icon" width="14" height="12" viewBox="0 0 14 12" fill="none">
              <path class="bar" d="M12 6H1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
              <path class="handle" d="M5.5 1.5L1 6L5.5 10.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="grid-button-next" type="button" aria-label="Next" style="display: none;">
            <svg class="custom-navigation-button-icon" width="14" height="12" viewBox="0 0 14 12" fill="none">
              <path class="bar" d="M1.5 6H12.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
              <path class="handle" d="M8 1.5L12.5 6L8 10.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="joii-product-grid-wrapper joii-qa-alt-grid" style="--qa-alt-rows: ${rows};">
        ${items.map((p, i) => qaAltCard(p, i)).join('')}
      </div>
      <div class="joii-product-grid-dots"></div>
    </div>
  `;

  const container = modalContent.querySelector('.joii-qa-alt-grid');
  container.addEventListener('scroll', () => qaGridSync(container), { passive: true });
  // Wait for layout before measuring columns
  requestAnimationFrame(() => requestAnimationFrame(() => qaGridSync(container)));
}


function qaAltCard(p, i) {
  const img = p.featured_image || (p.images && p.images[0]) || '';
  // Same rules as snippets/joii-price.liquid: a range when variant prices
  // differ, otherwise the price plus compare-at when it's higher. No "From".
  const price = p.price_varies
    ? `<span class="price-item actual-price price-varies">${formatMoney(p.price_min)} - ${formatMoney(p.price_max)}</span>`
    : `<span class="price-item actual-price">${formatMoney(p.price_min)}</span>`;
  const compare = !p.price_varies && p.compare_at_price_min > p.price_min
    ? `<span class="price-item compare-price">${formatMoney(p.compare_at_price_min)}</span>`
    : '';

  // From joii-product-title (brand/range in <strong>) and
  // joii-product-card-variants-info, same output as the product cards
  const info = qaAltState.info[p.handle] || {};
  const titleHtml = info.t || qaEsc(p.title);
  const hint = info.v
    ? `<div class="joii-prod-card-var-hint" style="margin-top: 4px; margin-bottom: 4px;">${qaEsc(info.v)}</div>`
    : '';
  const repeatPrice = qaRepeatPrice(p);
  const repeat = repeatPrice !== null && repeatPrice < p.price_min
    ? `<span class="qa-alt-repeat"><strong>${formatMoney(repeatPrice)}</strong> with <strong style="font-weight: 500;">Repeat<span class="qa-alt-save"> &amp; Save</span></strong></span>`
    : '';

  // Wishlist: same Fish Wishlist element and classes as the product cards,
  // on the first available variant (cards use selected_or_first_available_variant)
  const wishVariant = (p.variants.find(v => v.available) || p.variants[0]).id;

  // Quick add: identical markup to snippets/joii-quick-add.liquid (default mode)
  return `
    <div class="qa-alt-item">
      <a class="qa-alt-img" href="${p.url}" tabindex="-1">
        ${img ? `<img width="120" height="120" src="${qaImg(img, 300)}" alt="${qaEsc(p.title)}" loading="lazy">` : ''}
      </a>
      <wishlist-button-pdp
        class="fish-wishlist-button--pdp fish-wishlist-button--secondary joii-product-card-wish"
        data-variant-id="${wishVariant}"
        data-preselected-id="${wishVariant}"
        data-is-added="false"
      ></wishlist-button-pdp>
      <div class="qa-alt-info">
        <a class="product-title qa-alt-title" href="${p.url}" title="${qaEsc(p.title)}">${titleHtml}</a>
        <div class="qa-alt-bottom">
          ${hint}
          <div class="product-price">
            ${price}${compare}
          </div>
          ${repeat}
        </div>
      </div>
      <div class="joii-quick-add joii-qa-alt-add" data-index="${i}" role="button" tabindex="0"
        aria-label="${qaIsSimple(p) ? 'Add' : 'Choose options for'} ${qaEsc(p.title)}">
        <svg class="joii-quick-add-start" width="24" height="24" aria-hidden="true"><use href="#joii-icon-qa-start"></use></svg>
        <svg class="joii-quick-add-done" width="24" height="24" aria-hidden="true"><use href="#joii-icon-qa-done"></use></svg>
      </div>
    </div>
  `;
}


async function qaAltAdd(btn) {
  const p = qaAltState.products[Number(btn.dataset.index)];
  if (!p || btn.classList.contains('finished') || btn.classList.contains('qa-adding')) return;

  // Options or Repeat & Save: hand over to the normal quick add view
  if (!qaIsSimple(p)) {
    product = p;
    renderQuickAdd(p);
    modalContent.insertAdjacentHTML(
      'afterbegin',
      `<button type="button" class="joii-qa-alt-back">‹ Back to alternatives</button>`
    );
    return;
  }

  btn.classList.add('qa-adding');

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: p.variants[0].id, quantity: 1 })
    });
    if (!res.ok) throw new Error(`Add to basket failed (${res.status})`);

    // Same state the default quick add uses: .finished shows the green tick
    btn.classList.add('finished');
    btn.setAttribute('aria-label', `${p.title} added to basket`);
    quickAddUpdateCartNumber();
  } catch (err) {
    console.error(err);
  } finally {
    btn.classList.remove('qa-adding');
  }
}


/* ---------------------------------------------------------------------
   Carousel: same behaviour and maths as joii-slideshow.js grid mode
   --------------------------------------------------------------------- */

function qaGridMobile() {
  return window.matchMedia('(max-width: 767px)').matches;
}

function qaGridColumns(container) {
  const lefts = new Set();
  Array.from(container.children).forEach(item => {
    lefts.add(Math.round(item.getBoundingClientRect().left + container.scrollLeft));
  });
  return lefts.size;
}

function qaGridVisibleColumns(container) {
  const box = container.getBoundingClientRect();
  const seen = new Map();
  Array.from(container.children).forEach(item => {
    const r = item.getBoundingClientRect();
    const key = Math.round(r.left);
    if (!seen.has(key)) seen.set(key, r);
  });
  let visible = 0;
  seen.forEach(r => {
    const centre = r.left + r.width / 2;
    if (centre >= box.left && centre <= box.right) visible++;
  });
  return Math.max(1, visible);
}

function qaGridColumnWidth(container) {
  const first = container.children[0];
  if (!first) return container.clientWidth;
  const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
  return first.getBoundingClientRect().width + gap;
}

function qaGridSync(container) {
  const grid = container.closest('.joii-product-grid');
  if (!grid) return;

  const prev = grid.querySelector('.grid-button-previous');
  const next = grid.querySelector('.grid-button-next');
  const dotsCont = grid.querySelector('.joii-product-grid-dots');
  const maxScroll = container.scrollWidth - container.clientWidth;
  const atStart = container.scrollLeft <= 10;
  const atEnd = container.scrollLeft >= maxScroll - 1;

  // Arrows: disabled at the ends, hidden on mobile or when nothing scrolls
  if (prev) prev.classList.toggle('disabled', atStart);
  if (next) next.classList.toggle('disabled', atEnd);
  const showArrows = !qaGridMobile() && !(atStart && atEnd);
  [prev, next].forEach(b => { if (b) b.style.display = showArrows ? 'flex' : 'none'; });

  if (!dotsCont) return;

  // Dots: one per page on desktop, one per column on mobile (as theme)
  const totalColumns = qaGridColumns(container);
  const visible = qaGridVisibleColumns(container);
  const mobile = qaGridMobile();
  const total = mobile ? totalColumns : Math.ceil(totalColumns / visible);

  if (dotsCont.children.length !== total) {
    dotsCont.innerHTML = '';
    if (total > 1) {
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('div');
        dot.className = 'joii-product-grid-dot';
        dotsCont.appendChild(dot);
      }
    }
  }

  let index = mobile
    ? Math.round(container.scrollLeft / qaGridColumnWidth(container))
    : Math.round(container.scrollLeft / container.clientWidth);
  if (atEnd && !atStart) index = mobile ? totalColumns - visible : total - 1;
  index = Math.max(0, index);

  Array.from(dotsCont.children).forEach((dot, i) => {
    dot.classList.remove('active', 'before-active', 'after-active');
    const span = mobile ? visible : 1;
    if (i >= index && i < index + span) dot.classList.add('active');
    if (i === index - 1) dot.classList.add('before-active');
    if (i === index + span) dot.classList.add('after-active');
  });
}

function qaGridArrow(btn) {
  const grid = btn.closest('.joii-product-grid');
  const container = grid && grid.querySelector('.joii-product-grid-wrapper');
  if (!container) return;
  const maxScroll = container.scrollWidth - container.clientWidth;
  const step = btn.classList.contains('grid-button-previous') ? -container.clientWidth : container.clientWidth;
  container.scrollTo({
    left: Math.max(0, Math.min(maxScroll, container.scrollLeft + step)),
    behavior: 'smooth'
  });
}

// Mobile dots map to columns. The theme's handler uses children[i], which
// lands on the wrong card in a multi-row grid, so the popup handles it here.
function qaGridDot(dot) {
  const grid = dot.closest('.joii-product-grid');
  const container = grid && grid.querySelector('.joii-product-grid-wrapper');
  if (!container) return;
  const i = Array.from(dot.parentElement.children).indexOf(dot);
  const left = qaGridMobile()
    ? i * qaGridColumnWidth(container)
    : i * container.clientWidth;
  container.scrollTo({ left, behavior: 'smooth' });
}


/* ---------------------------------------------------------------------
   Helpers
   --------------------------------------------------------------------- */

// Same rule openQuickAdd uses for adding without the modal
function qaIsSimple(p) {
  const hasPlans = p.selling_plan_groups && p.selling_plan_groups.length > 0;
  return p.variants.length === 1 && p.variants[0].available && !hasPlans;
}

// Lowest Repeat & Save price across variants, or null
function qaRepeatPrice(p) {
  let lowest = null;
  (p.variants || []).forEach(v => {
    (v.selling_plan_allocations || []).forEach(a => {
      if (lowest === null || a.price < lowest) lowest = a.price;
    });
  });
  return lowest;
}

function qaAltSetSeeMore() {
  const seeMore = modal.querySelector('.joii-quick-add-see-more');
  const url = qaAltState.source && qaAltState.source.url;
  if (seeMore && url) seeMore.setAttribute('href', url);
}

function qaImg(src, width) {
  return `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
}

function qaEsc(str) {
  return String(str ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

// Only popup-specific layout lives here. Arrows, dots, the grid wrapper
// and .joii-quick-add all use their existing joii-custom.css styles.
// Card styles are copied from the Top Rated section's inline <style>,
// which only loads on /collections.
function qaAltInjectStyles() {
  if (document.getElementById('joii-qa-alt-styles')) return;
  const style = document.createElement('style');
  style.id = 'joii-qa-alt-styles';
  style.textContent = `
    /* Alternatives screen only: grey popup background. The normal quick
       add view (including after "Choose") stays white. */
    .joii-modal-content:has(.joii-qa-alt) { background: #f9f9f9; }

    .joii-qa-alt { display: flex; flex-direction: column; gap: 10px; width: 100%; min-width: 0; }
    .joii-qa-alt.joii-product-grid > * { max-width: 100%; padding-left: 0; padding-right: 0; }
    .joii-qa-alt-loading { color: #828282; margin: 0; padding: 20px 0; }

    .joii-qa-alt-head { display: flex; align-items: flex-end; gap: 10px; }
    .joii-qa-alt-head-text { flex: 1 1 auto; min-width: 0; padding-right: 90px; }
    .joii-qa-alt-head h2 { margin: 6px 0 4px; }
    .joii-qa-alt-head p { margin: 0; color: #515151; }
    /* Theme's own Out Of Stock badge (joii-product-badge.liquid); colours and
       padding come from the global .product-badge / .sold-badge styles.
       Bold + nowrap match .joii-product-card-item .product-card-badges span. */
    .joii-qa-alt-badges { display: flex; }
    .joii-qa-alt-badges .product-badge { font-weight: bold; text-wrap: nowrap; margin: 0 !important; position: absolute; top: 0; left: 0; }
    .joii-qa-alt .joii-product-grid-controls { margin-left: auto; flex: 0 0 auto; }

    /* Grid: Top Rated layout, sized for the popup instead of the viewport */
    .joii-qa-alt .joii-product-grid-wrapper.joii-qa-alt-grid {
      --horizontal-items: 1.5;
      --horizontal-gap: 15;
      --vertical-gap: 10;
      grid-template-rows: repeat(var(--qa-alt-rows, 3), 120px);
      /*background: #f4f4f4;*/
      border-radius: 10px;
      padding: 10px;
      scroll-padding-left: 10px;
    }

    /* Card: copied from .top-rated-category-item / .trci-info */
    .qa-alt-item {
      display: flex; flex-direction: row;
      background: white; border-radius: 10px; position: relative; min-width: 0;
      box-shadow: 1px 1px 4px 1px #e7e7e7;
    }
    /* Wishlist heart: horizontal card, so it sits top-right of the card,
       above the "+" (bottom-right), not over the image. Look and size come
       from .joii-product-card-wish in joii-custom.css. */
    .qa-alt-item > .joii-product-card-wish { top: 4px; right: 4px; }
    .qa-alt-img { flex: 0 0 auto; display: flex; align-items: center; overflow: hidden; border-radius: 10px 0 0 10px; }
    .qa-alt-img img { width: 120px; height: 120px; padding: 5px; object-fit: contain; display: block; }
    .qa-alt-info {
      display: flex; flex-direction: column; justify-content: space-between;
      padding: 15px 15px 8px 15px; height: 100%; min-width: 0; flex: 1 1 auto;
      border-left: 1px solid #26262614;
    }
    .qa-alt-item .product-title {
      color: #000; font-size: 14px; line-height: 17px; margin-bottom: 5px; padding-right: 30px;
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
    }
    .qa-alt-bottom { display: flex; flex-direction: column; width: 100%; padding-right: 30px; }
    /* Title and price block never shrink: the row grows instead of the title
       being squashed to nothing (was cutting titles off on mobile) */
    .qa-alt-item .product-title, .qa-alt-bottom { flex-shrink: 0; }
    .qa-alt-item .product-price { margin-bottom: 0; }
    .qa-alt-item .actual-price { margin-bottom: 0; }
    .qa-alt-repeat { color: #828282; font-size: 11px; font-weight: 400; padding-top: 3px; }
    .joii-qa-alt-add.qa-adding { opacity: .5; pointer-events: none; }

    .joii-qa-alt-back {
      background: none; border: none; padding: 0 0 10px; color: #207EA7;
      font-weight: 600; cursor: pointer; display: block;
    }

    @media (max-width: 900px) {
      .joii-qa-alt .joii-product-grid-wrapper.joii-qa-alt-grid {
        --horizontal-items: 1.3;
        grid-template-rows: repeat(var(--qa-alt-rows, 3), minmax(100px, auto));
      }
      .qa-alt-img img { width: 90px; height: 90px; }
      .qa-alt-item .product-title { font-size: 12px; line-height: 15px; }
    }
    @media (max-width: 767px) {
      .joii-qa-alt .joii-product-grid-wrapper.joii-qa-alt-grid {
        --horizontal-items: 1.15; --horizontal-gap: 8; --vertical-gap: 8;
      }
      .joii-qa-alt-head-text { padding-right: 0; }
      .qa-alt-info { padding: 10px 12px; gap: 4px; }
      /* Same wording as the mobile product cards: "with Repeat" */
      .qa-alt-save { display: none; }

      /* Narrow phones: wider cards and a smaller image so the title, price
         range and Repeat line fit without wrapping */
      @media (max-width: 420px) {
        .joii-qa-alt .joii-product-grid-wrapper.joii-qa-alt-grid { --horizontal-items: 1.06; }
        .qa-alt-img img { width: 72px; height: 72px; padding: 4px; }
        .qa-alt-info { padding: 8px 10px; }
        .qa-alt-bottom { padding-right: 28px; }
        .qa-alt-item .product-price { white-space: nowrap; }
        .qa-alt-item .product-price .price-item { font-size: 13px; }
      }

      /* While the alternatives list is showing, hide "See more" on mobile
         and keep the X top-right. The normal quick add view keeps the
         theme's mobile layout. */
      #joii-quick-add-modal:has(.joii-qa-alt) .joii-quick-add-see-more { display: none; }
      #joii-quick-add-modal:has(.joii-qa-alt) .close-actions {
        position: absolute;
        top: 10px;
        right: 10px;
        width: auto;
        justify-content: flex-end;
        z-index: 2;
      }
    }
  `;
  document.head.appendChild(style);
}